import axios from 'axios';

// 创建axios实例
const service = axios.create({
  // api 的 base_url
  // 设置为process.env.BASE_API是取config文件夹下dev.env.js/prod.env.js中配置的信息
  // 设置为reqCfg.requestUrl是取static文件夹下RequestConfig.js中配置的信息
  baseURL: request3.yft,
  timeout: request.timeout, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  cfg => {
    // 让每个请求携带自定义token 请根据实际情况自行修改
    const publicToken = PUBLIC_TOKEN || Math.floor(Math.random() * (999999999999999999 - 100000000000000000 + 1) + 100000000000000000);
    cfg.headers['token'] = localStorage.getItem('token') || publicToken;
    cfg.headers['productid'] = localStorage.getItem('productid') || '';
    cfg.headers['AppSource'] = 'H5';
    return Promise.resolve(cfg);
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  res => {
    return Promise.resolve(res.data);
  },
  error => {
    return Promise.reject(error);
  }
);

export default service;
